const Menu2 =  [
  { header: 'Apps' },
  // {
  //   title: 'Dashboard',
  //   group: 'apps',
  //   icon: 'dashboard',
  //   name: 'Dashboard',
  // },
  // { divider: true },
  {
    title: 'Membres',
    group: 'widgets',
    component: 'widgets',
    icon: 'widgets',
    items: [
      // { name: 'allmembers', title: 'Membres Total', component: 'components/widget-allmembers' },
      { name: 'statistic', title: 'Membres Aujourd\'hui', badge: 'new', component: 'components/widget-todaylist' },
      // { name: 'chart', title: 'Serviteurs', component: 'components/widget-serviteurs' },
      // { name: 'list', title: 'Donnés Vides', component: 'components/widget-empty-list' },
      // { name: 'referrals', title: 'Références', component: 'components/widget-referrals' },
      { name: 'newmember', title: 'Nouveau membre', component: 'components/newmember' },
      { name: 'search', title: 'Recherche', component: 'components/widget-search' },
     
    ]
  },
  // {
  //   title: 'Bénévolats',
  //   group: 'apps',
  //   icon: 'supervised_user_circle',
  //   target: '_blank',
  //   name: 'Bénévolats',
  // },
  // {
  //   title: 'Employés',
  //   group: 'apps',
  //   name: 'Employees',
  //   icon: 'people',
  // },
  // {
  //   title: 'Messages',
  //   group: 'messages',
  //   component: 'messages',
  //   icon: 'message',
  //   items: [
  //     { name: 'Chat', title: 'Au serviteurs', component: 'Chat' },
  //     { name: 'orange_tigo', title: 'À une paroisse', component: 'components/providers-orange_tigo' },
  //     { name: 'airtel', title: 'À un membre specific', component: 'components/providers-airtel' },
  //     // { name: 'post', title: 'Post', component: 'components/widget-post' },
  //   ]
  // },  
  // { divider: true },
  // {
  //   title: 'Nouvelles donées',
  //   group: 'forms',
  //   component: 'forms',
  //   icon: 'add_circle',
  //   items: [
  //     { name: 'newmember', title: 'Nouveau membre', component: 'components/newmember' },
  //     // { name: 'newproject', title: 'Nouveau projet', component: 'components/newproject' },
  //     // { name: 'basic', title: 'General', component: 'components/basic-forms' },
  //     // { name: 'selects', title: 'Selects', badge: 'new', component: 'components/selects' },
  //     // { name: 'selection-controls', title: 'Selection Controls', component: 'components/selection-controls' },
  //     // { name: 'text-fields', title: 'Text Fields', component: 'components/text-fields' },
  //     // { name: 'newemployee', title: 'Nouveau employé', component: 'components/newemployee' },
  //     // { name: 'editors', title: 'Editors', component: 'components/editors' },
  //   ]
  // }
];

// reorder menu
Menu2.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu2;



// WEBPACK FOOTER //
// ./src/api/menu2.js